export default __webpack_public_path__ + "static/media/TheNewYear_11.54ca9d68.png";